<template>
  <div>
    <v-card v-if="!printTickets">
      <confirmation-order :email="checkEmail" />
      <v-container>
        <confirmation-order-number />
        <confirmation-payment :postOrder="postOrder" />
        <div v-if="postOrder.status === 'Aprovado'">
          <v-divider class="pb-3"></v-divider>
          <v-btn
            block
            round
            class="normal-text mb-4"
            color="primary"
            dark
            target="_blank"
            v-if="showAccessLiveEvent"
            :href="onlineEventUrl"
            >Acessar o evento</v-btn
          >
          <confirmation-delivery v-else :ticketUrl="ticketUrl" />
        </div>
        <v-divider class="pb-3"></v-divider>
        <v-layout>
          <v-flex xs1 :class="isSmAndDown ? 'mr-2' : ''">
            <v-img flat width="20"></v-img>
          </v-flex>
          <v-flex>
            <event-organizer v-if="postOrder.status !== 'Em análise'" />
          </v-flex>
        </v-layout>
        <v-divider class="pb-3 mt-3" v-if="postOrder.mensagem"></v-divider>
        <event-message v-if="postOrder.mensagem && orderData && orderData.orderData.status !== 'W'" />
      </v-container>
    </v-card>
    <v-card height="300" v-else>
      <div v-if="loading" class="rowPrint">
        <h2 class="mt-4">Imprimindo Ingressos</h2>
        <v-progress-circular
          class="mt-4"
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else class="rowPrint">
        <h2 class="my-4">Compra Finalizada!</h2>
        <v-btn
          round
          color="primary"
          :style="$route.name === 'totem' ? 'height: 45px !important' : ''"
          depressed
          @click="reset"
          class="normal-text"
          >Nova Compra</v-btn
        >
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmationOrder from './ConfirmationOrder';
import ConfirmationOrderNumber from './ConfirmationOrderNumber';
import ConfirmationPayment from './Payment/ConfirmationPayment';
import ConfirmationDelivery from './Delivery/ConfirmationDelivery';
import EventOrganizer from './Delivery/EventOrganizer';
import EventMessage from './Delivery/EventMessage';
import $http from '@/http.js';
import axios from 'axios';

export default {
  data() {
    return {
      dialog: false,
      loading: true,
      array64: [],
      printNumber: 0,
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.getElementsByClassName(
      'v-dialog v-dialog--active'
    )[0].scrollTop = 0;
  },
  components: {
    ConfirmationOrder,
    ConfirmationPayment,
    ConfirmationDelivery,
    EventOrganizer,
    EventMessage,
    ConfirmationOrderNumber,
  },
  // https://soulapi.dev03.btservers.com.br/api/v2/tickets/stream/png/base64/100/100/28605/187/73190252
  computed: {
    ...mapGetters([
      'buyerData',
      'ticketUrl',
      'postOrder',
      'userToken',
      'body',
      'isEventOnline',
      'eventID',
      'orderTickets',
      'nominationStartDate',
      'printTickets',
      'orderData',
      'cartProducts',
      'paymentOption',
      'eventDetails',
    ]),
    onlineEventUrl() {
      const email = this.postOrder.email;
      const ticket = this.orderTickets[0].codigo;
      switch (process.env.VUE_APP_ENV) {
        case 'development':
          return `http://live.dev.btservers.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
        case 'homologation':
          return `http://live.homolog.btservers.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
        default:
          return `http://live.blueticket.com.br/event-${this.eventID}/login?e=${email}&i=${ticket}`;
      }
    },
    showAccessLiveEvent() {
      if (
        this.isEventOnline &&
        this.orderTickets.length === 1 &&
        this.orderTickets[0]
      ) {
        const namedTicket = this.orderTickets[0].dados_extras;
        const nome = namedTicket.find(n => n.tipo === 'nome');
        const email = namedTicket.find(n => n.tipo === 'email');
        if (nome && email && nome.valor && email.valor) return true;
        else return false;
      } else return false;
    },
    checkEmail() {
      if (this.postOrder && this.postOrder.email) return this.postOrder.email;
      else if (this.buyerData && this.buyerData.email)
        return this.buyerData.email;
      else {
        const userProps = JSON.parse(localStorage.getItem('userProps'));
        return userProps ? userProps.email : '';
      }
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total;
    },
    googleAds() {
      return this.findTokenPerType('google_ads');
    },
    // orderUrl() {
    //   return this.userToken
    //     ? `${process.env.VUE_APP_BT_URL}/ingressos/${this.body.hash_pedido}`
    //     : '';
    // },
  },
  mounted() {
    if (this.paymentOption === 'PIX' && this.printTickets)
      this.getArrayBase64();

    this.startGoogleAds();
  },
  created() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('unload', this.handleUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('unload', this.handleUnload);
  },
  watch: {
    orderData(v) {
      if (v && this.printTickets) this.getArrayBase64();
    },
    array64(v) {
      if (
        v &&
        v.length &&
        this.orderData &&
        this.orderData.orderData &&
        this.orderData.orderData.ingressos &&
        v.length === Object.values(this.orderData.orderData.ingressos).length
      ) {
        this.uploadImages();
      }
    },
    printNumber(v) {
      if (
        v &&
        this.orderData &&
        this.orderData.orderData &&
        this.orderData.orderData.ingressos &&
        v === Object.values(this.orderData.orderData.ingressos).length
      ) {
        this.loading = false;
        setTimeout(() => {
          this.reset();
        }, 10000);
      }
    },
  },
  methods: {
    async print(path) {
      await this.$store.dispatch('printTotem', {
        printer: 'epson-t88',
        template: `{image, path: ${path}}`,
      });
      this.printNumber += 1;
    },
    async getArrayBase64() {
      if (
        this.printTickets &&
        this.orderData &&
        this.orderData.orderData &&
        this.orderData.orderData.ingressos
      ) {
        for (
          let i = 0;
          i < Object.values(this.orderData.orderData.ingressos).length;
          i++
        ) {
          await this.getImage(
            Object.values(this.orderData.orderData.ingressos)[i]
              .url_pos_impressao
          );
          await this.waitNext('2000');
        }
      }
    },
    async uploadImages() {
      console.log('Percorrendo array de ingressos');
      for (
        let i = 0;
        i < Object.values(this.orderData.orderData.ingressos).length;
        i++
      ) {
        await this.upload({
          filename: `ticket-${
            Object.values(this.orderData.orderData.ingressos)[i].codigo_barras
          }.jpg`,
          data: this.array64[i],
        });
        await this.waitNext('8000');
        console.log('done upload');
      }
    },
    async upload(params) {
      console.log(
        'Upload imagem http://localhost:3000/config/logo e em seguida impresão'
      );
      try {
        return await axios
          .post('http://localhost:3000/config/logo', params)
          .then(resp => {
            console.log('http://localhost:3000/config/logo', resp);
            if (resp.data === 'OK') this.print(params.filename);
          });
      } catch (error) {
        console.error('http://localhost:3000/config/logo', error);
        throw error;
      }
    },
    async getImage(url) {
      console.log('Chamando requisição url_pos_impressao para pegar base64');
      try {
        return await axios.get(url).then(resp => {
          console.log('url_pos_impressao', resp);
          this.array64.push(resp.data);
        });
      } catch (error) {
        console.error('url_pos_impressao', error);
        throw error;
      }
    },
    async reset() {
      const evento = this.$store.getters.eventID;
      const checkoutState =
        JSON.parse(localStorage.getItem(`checkoutState`)) || {};
      this.cartProducts.forEach(product => {
        product.forEach(async el => {
          if (el.seats) {
            el.seats.forEach(async sc => {
              await this.$store.dispatch('unbookPurchaseSeats', sc);
            });
          }
        });
      });
      this.$store.commit('SET_PRINT_TICKETS', false);
      await this.$store.dispatch('deleteCheckoutState', evento);
      if (
        checkoutState &&
        checkoutState[evento] &&
        checkoutState[evento].userToken
      )
        await this.$store.dispatch('getClientData');
      await this.$store.dispatch('loadCheckoutState', evento);
      await this.$store.dispatch('resetSelection');
      await this.$store.dispatch('setResetPurchase', false);
    },

    handleBeforeUnload() {
      this.reset();
    },
    handleUnload() {
      this.reset();
    },

    async waitNext(seconds) {
      return new Promise(resolve => {
        setTimeout(resolve, Number(seconds));
      });
    },

    startGoogleAds() {
      if (this.googleAds) {
        this.$gtag.event('conversion', {
          send_to: this.googleAds,
          transaction_id: `${this.eventID}-${this.body.codigo_pedido}`,
          event_category: 'Compra',
          event_label: 'Total',
          value: parseFloat(this.productsTotal),
          event_value: parseFloat(this.productsTotal),
          currency: 'BRL',
        });
      }
    },

    findTokenPerType(type) {
      return this.eventDetails &&
        this.eventDetails.integracoes_publicas &&
        this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
        ? this.eventDetails.integracoes_publicas.find(i => i.tipo === type)
            .credenciais.token
        : '';
    },
  },
};
</script>

<style>
.rowPrint {
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.divDialog .v-dialog {
  background: transparent !important;
}
.v-dialog .dialogPrint {
  background: transparent;
}
.confirmation-title {
  margin: 8px 0;
}
.dialogPrint {
  background: none !important;
}
.confirmation-subtitle {
  margin-bottom: 6px;
}
</style>
